function CreditRepo({ GRAPHQL_URL, httpClient }) {
  this.getCreditMapping = ({ year }, { success, failure }) => {
    const query = `query MyQuery($year: Int!) {
        getCreditMapping(year: $year) {
          error {
            code
            message
            statusCode
          }
          data {
              promotionCode
              accountId
              year
              reference
              amount
              startDate
              endDate
              usedCredit
              elementMap {
                element1Id
                element2Id
                element3Id
                element4Id
              }
            }
        }
      }`

    httpClient.request(
      {
        method: 'POST',
        url: GRAPHQL_URL,
        data: {
          query,
          variables: {
            year
          }
        }
      },
      {
        success: (response) => {
          success(response)
        },
        failure: (error) => failure(error)
      }
    )
  }

  this.listUnallocatedPromotionCodes = ({ year }, { success, failure }) => {
    const query = `query ListUnallocatedPromotionCodes($year: Int!) {
        listUnallocatedPromotionCodes(year: $year) {
          error {
            code
            message
            statusCode
          }
          data {
            promotionCode
            creditAccountApplied
            amount
            startDate
            endDate
            year
          }
        }
      }`

    httpClient.request(
      {
        method: 'POST',
        url: GRAPHQL_URL,
        data: {
          query,
          variables: {
            year
          }
        }
      },
      {
        success: (response) => {
          success(response)
        },
        failure: (error) => failure(error)
      }
    )
  }

  this.getCreditMappingByElement = ({ year, element1Id, element2Id, element3Id, element4Id }, { success, failure }) => {
    const query = `query MyQuery($year: Int!, $element1Id: String!, $element2Id: String!, $element3Id: String!, $element4Id: String!) {
        getCreditMappingByElement(year: $year, element1Id: $element1Id, element2Id: $element2Id, element3Id: $element3Id, element4Id: $element4Id) {
          error {
            code
            message
            statusCode
          }
          data {
              promotionCode
              year
              reference
              amount
              startDate
              endDate
              usedCredit
              elementMap {
                element1Id
                element2Id
                element3Id
                element4Id
              }
            }
        }
      }`

    httpClient.request(
      {
        method: 'POST',
        url: GRAPHQL_URL,
        data: {
          query,
          variables: {
            year,
            element1Id,
            element2Id,
            element3Id,
            element4Id
          }
        }
      },
      {
        success: (response) => {
          success(response)
        },
        failure: (error) => failure(error)
      }
    )
  }

  this.createCreditMapping = ({ creditMapping }, { success, failure }) => {
    const query = `mutation MyMutation ($creditMapping: CreditMappingInput!) {
        createCreditMapping(creditMapping: $creditMapping) {
          error {
            statusCode
            message
            code
          }
          data {
              promotionCode
              year
              reference
              amount
              startDate
              endDate
              usedCredit
              elementMap {
                element1Id
                element2Id
                element3Id
                element4Id
              }
            }
        }
      }`

    httpClient.request(
      {
        method: 'POST',
        url: GRAPHQL_URL,
        data: {
          query,
          variables: {
            creditMapping
          }
        }
      },
      {
        success: (response) => {
          success(response)
        },
        failure: (error) => failure(error)
      }
    )
  }
}

export default CreditRepo
